/**
 * Azure Blob Storage service (Browser-compatible version)
 * Uses SAS tokens for browser-based uploads/downloads
 */
export class AzureBlobStorageService {
  constructor() {
    const config = {
      backendUrl: 'https://sensaytts.blob.core.windows.net/sensay-assessment',
      containerName: 'test-uploads',
    }

    this.config = config;
    this.containerUrl = config.containerUrl || 'https://sensaytts.blob.core.windows.net/sensay-assessment';
    this.sasToken = config.sasToken || 'sp=racw&st=2026-01-21T12:04:30Z&se=2030-01-21T20:19:30Z&spr=https&sv=2024-11-04&sr=c&sig=oTpf7tZvVWN7RWYJ%2BftgurMCTscgl1C3s5xm4bQD77E%3D';
  }

  async initialize() {
    // Verify container URL is configured
    if (!this.containerUrl) {
      throw new Error('Container URL is required for Azure Blob Storage');
    }
    return true;
  }

  async uploadFile(file) {
    const fileName = `test-${Date.now()}-${file.name}`;

    // Construct upload URL with SAS token
    const uploadUrl = `${this.containerUrl}/${fileName}?${this.sasToken}`;

    // Upload file to Azure with SAS token
    const uploadResponse = await fetch(uploadUrl, {
      method: 'PUT',
      headers: {
        'x-ms-blob-type': 'BlockBlob',
        'Content-Type': file.type,
      },
      body: file,
    });

    if (!uploadResponse.ok) {
      throw new Error('Failed to upload file');
    }

    const publicUrl = uploadUrl.split('?')[0]; // Remove SAS token
    return { fileName, url: publicUrl };
  }

  async downloadFile(fileName) {
    // Construct download URL with SAS token
    const downloadUrl = `${this.containerUrl}/${fileName}?${this.sasToken}`;

    // Download file using SAS token
    const fileResponse = await fetch(downloadUrl);
    if (!fileResponse.ok) {
      throw new Error('Failed to download file');
    }

    return await fileResponse.blob();
  }

  getPublicUrl(fileName) {
    return `${this.containerUrl}/${fileName}`;
  }
}
